import { defaultEmployeeFormValues, EmployeeFormValues } from "../common/EmployeeFormValues";
import { AccidentFormValues, defaultAccidentFormValues } from "./AccidentFormValues";
import { Language } from "../enums/Language";
import { ConditionType } from "../enums/ConditionType";
import { TreatingPhysician } from "../domain/TreatingPhysician";

export type AccidentEmployeeFormValues = EmployeeFormValues & AccidentFormValues & {
    textPermission: boolean,
    preferredLanguage: Language,
    otherLanguage: string,
    claimDates: [{
        startDate: string
    }],
    conditionType: ConditionType,
    dependents: string,
    conditionDetails: string,
    injuryDetails: string,
    youthSportingEvent: string,
    firstVisit: string,
    policeReport: string,
    timeOfInjury: string,
    locationOfInjury: string,
    workRelated: boolean,
    lossOfLife: string,
    dateOfDeath: string,
    facilityName: string,
    facilityPhoneNumber: string,
    treatingPhysicians: TreatingPhysician[],
    hipaaConsent: boolean,
    confidentialMessages: string,
    permissionContactName: string,
    relationshipType: string,
    otherRelationshipDescription: string,
    representativeAuthority: string,
    authorityDescription: string,
    authorityDocumentation: string,
}

export const defaultAccidentEmployeeFormValues = {
    ...defaultEmployeeFormValues,
    ...defaultAccidentFormValues,
    textPermission: false,
    preferredLanguage: Language.ENGLISH,
    otherLanguage: '',
    claimDates: [{
        startDate: ''
    }],
    conditionType: ConditionType.INJURY,
    dependents: '',
    conditionDetails: '',
    injuryDetails: '',
    youthSportingEvent: '',
    firstVisit: '',
    policeReport: '',
    timeOfInjury: '',
    locationOfInjury: '',
    workRelated: false,
    lossOfLife: "",
    dateOfDeath: '',
    facilityName: '',
    facilityPhoneNumber: '',
    treatingPhysicians: [{
        physicianFirstName: '',
        physicianLastName: '',
        physicianPhoneNumber: '',
    }],
    hipaaConsent: false,
    confidentialMessages: '',
    permissionContactName: '',
    relationshipType: '',
    otherRelationshipDescription: '',
    representativeAuthority: 'No',
    authorityDescription: '',
    authorityDocumentation: '',
}
